import React from 'react';
import img_1 from './../../img/nature/nat_1.jpg';
import img_2 from './../../img/nature/nat_3.jpg';
import './style.css';

const ServicesSlide = () => {
  return ( 
    <section className="services__slide section" id='services'>
        <div className="container">
          <div id="slide2" className="slide-2">
          <h2 className="title-2">My <span className='accent'>Services</span></h2>
            <div className="services__slide-wrapper">
              <p className="services__slide-subtitle">I offer a wide range of photography services to help you capture the important moments in your life:</p>
              <ul className="services__slide-list">
                <li>
                Portrait sessions: Individual, family, and children's portraits for every taste. I’ll help you reveal your uniqueness and create an atmosphere where everyone feels comfortable.
                I’m also happy to photograph your pets, capturing their special moments and personalities.
                </li>
                <li>
                Family event photography: Birthdays, anniversaries, and other important occasions. Photos that will preserve the warmth and joy of your family celebrations.
                </li>
                <li>
                Small weddings and celebrations: The special moments of your wedding day — from intimate ceremonies to cozy celebrations, I capture all the key details and emotions.
                </li>
                <li>
                Commercial photography: Creating visual content for your business — from product photos for marketplaces to stylish images for your website and social media.
                </li>
                <li>
                I use modern professional equipment and have expertise in artistic photography and photo editing, ensuring high-quality results. I also offer flexible shooting options—both in terms of scheduling and locations. Whether it’s a studio session, an on-site shoot, or outdoor photography, we can tailor the session to your preferences and goals.
                </li>
              </ul>
              <p className='services__slide-subtitle accent'>Life is full of important events, and every photograph is an opportunity to extend those happy moments.</p>
            </div>
            <img src={img_1} alt='slide'/>
            <img src={img_2} alt='slide'/>
          </div>
        </div>

        </section>
   );
}
 
export default ServicesSlide;